// extracted by mini-css-extract-plugin
export default {"page":"aN","wrapper":"bN","text":"cN","icons":"eN","icon":"fN","icon_text":"gN","carousel_wrapper":"hN","slide":"iN","image":"jN","arrows":"kN","prev":"lN","modal_root":"mN","x_mark":"nN","modal":"oN","images":"pN","main_image":"qN","name":"rN"};
    if(module.hot) {
      // 1714654894282
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  